export default __webpack_public_path__ + "static/media/WestSettlementofDinogMap.b0614389.jpg";